export const config = {
  title: "Tameron",
  company_logo: "tameron.png",
  logo_placements: ["Right Sleeve", "Front","Left Chest"],
  show_modification_thumbnail: true,
  minimum_apparel_order: true,
  render_logo_preview: true,
  embroideries: {
    mens: ["Tameron"],
    womens: ["Tameron"],
    hat: ["Tameron"],
    customs: [],
  },
  email_recipients: ["lbudbill@gpcorp.com", "lbudbell@comcast.net"],
  stores: [],    
  bypass_codes: ["TAMERO"],
  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [
    { name: "Louis Budbill", phone: "678-287-1659" },
    { name: "Glenn Rodney", phone: "678-287-1608" },
  ],
  route_prefix: "/tameron",
  paypal_not_supported: true,
  password: "TameroN",
};
